import clsx from 'clsx'
import PhoneInput, {
  isValidPhoneNumber,
  isPossiblePhoneNumber,
} from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { Check, WarningCircle } from 'phosphor-react'

interface CustomPhoneInputProps {
  label?: string
  value?: string
  placeholder?: string
  onChange: (value: string | undefined) => void
  onBlur?: () => void
  name?: string
  isValid: boolean
  errorMessage?: string
  isHighlighted?: boolean
  isDisabledAttrStyled?: boolean
  isSubmitted: boolean
}

export const CustomPhoneInput = ({
  label,
  value,
  onChange,
  onBlur,
  name,
  isValid,
  errorMessage,
  isHighlighted,
  isSubmitted,
  placeholder,
  isDisabledAttrStyled = true,
}: CustomPhoneInputProps) => {
  const isPossible = value ? isPossiblePhoneNumber(value) : false
  const isValidNumber = value ? isValidPhoneNumber(value) : false

  const showError = Boolean(
    errorMessage || (isSubmitted && (!isPossible || !isValidNumber))
  )

  return (
    <label className="block w-full">
      {label && (
        <span className="block mb-1 text-xs lg:text-sm text-grey-800 lg:mb-1">
          {label}
        </span>
      )}

      <div className="relative">
        <PhoneInput
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          defaultCountry="BR"
          placeholder={placeholder}
          className={clsx(
            'p-3 pr-10 lg:pr-12 w-full rounded-none outline-none border-1 font-normal text-xs lg:font-sans lg:py-1 lg:text-sm',
            {
              'border-gray-400': !showError && !isHighlighted,
              'border-red-500': showError,
              'focus:border-grey-700': !showError,
              'border-grey-900 focus:border-grey-900': isHighlighted,
              'disabled:bg-grey-300 disabled:text-grey-500':
                isDisabledAttrStyled,
            }
          )}
          name={name}
        />

        <div className="absolute flex top-1/2 right-4 -translate-y-2/4">
          {showError ? (
            <WarningCircle className="text-lg lg:text-2xl text-[#FF4949]" />
          ) : (
            isValid && <Check className="text-lg lg:text-2xl text-[#08B919]" />
          )}
        </div>
      </div>

      {showError && (
        <p className="mt-2 text-[#FF4949] text-xs">{errorMessage}</p>
      )}
    </label>
  )
}
